





















/**
 * @copyright       Palace Resorts
 * @description     Pantalla de listado de documentos por factura por OC
 * @author          Leticia Beltrán
 * @creationDate    13/08/2021
 */

import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import SearchInvoiceProv from "../../components/SearchInvoice/SearchInvoiceProv.vue";
import BreadcrumbNav from "@/components/Breadcrumbs/BreadcrumbNav.vue";

export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    SearchInvoiceProv,
    BreadcrumbNav,
  },
  data() {
    return {
      moduleName: "Listado de documentos",
    };
  },
  methods: {},
});
